<template>
  <div v-if="reportBuilt" class="vx-row">
    <div class="vx-col w-1/3" v-if="shouldDisplayDonutChart() && charts[0]">
      <div class="title">{{ charts[0].name }}</div>
      <vue-apex-charts
        height="300"
        :options="charts[0].chartOptions"
        :series="charts[0].chart.series"
      ></vue-apex-charts>
    </div>
    <div class="vx-col w-2/3" v-if="shouldDisplayDonutChart() && charts[1]">
      <div class="title">{{ charts[1].name }}</div>
      <vue-apex-charts
        height="300"
        :options="charts[1].chartOptions"
        :series="
          charts[1].chart.type.toLowerCase() === 'pie' ||
          charts[1].chart.type.toLowerCase() === 'donut'
            ? charts[1].chart.series[0].data
            : charts[1].chart.series
        "
      ></vue-apex-charts>
    </div>
    <div class="vx-col w-full" v-else>
      <div v-for="(chart, idx) in chartsInOut" :key="idx">
        <div :class="getVehicleTypeClass(chart.name)">
          <font-awesome-icon
            v-if="chart.name === 'Motorcycle Chart'"
            icon="fa-solid fa-motorcycle"
            size="1x"
          />
          <font-awesome-icon
            v-if="chart.name === 'Car Chart'"
            icon="fa-solid fa-car"
            size="1x"
          />
          <font-awesome-icon
            v-if="chart.name === 'Other Vehicle Chart'"
            icon="fa-solid fa-truck"
            size="1x"
          />
          <font-awesome-icon
            v-if="chart.name === 'Person Chart'"
            icon="fa-solid fa-person"
            size="1x"
          />
          {{ chart.name }}
        </div>
        <vue-apex-charts
          height="300"
          :options="chart.chartOptions"
          :series="chart.chart.series"
        ></vue-apex-charts>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import dummyData from "../chart_counting.json";

export default {
  props: ["lists", "site", "reportBuilt"],
  data() {
    return {
      charts: [],
      chartsInOut: [],
    };
  },
  computed: {
    dummyData() {
      return dummyData;
    },
  },
  components: {
    VueApexCharts,
  },
  mounted() {
    this.buildChartData();
    this.buildChartDataInOut();
  },
  methods: {
    getVehicleTypeClass(vehicleType) {
      switch (vehicleType.toLowerCase()) {
        case "car chart":
          return "car-chart-class";
        case "motorcycle chart":
          return "motorcycle-chart-class";
        case "other vehicle chart":
          return "other-vehicle-chart-class";
        case "person chart":
          return "person-chart-class";
        default:
          return "default-chart-class";
      }
    },
    shouldDisplayDonutChart() {
      return this.lists[0].chart.series[0].name.includes("Data Donut");
    },

    buildChartData() {
      this.lists.map((x) => {
        // Check if site id is 36
        const hidePerson = this.site === 0;
        console.log("Original Series:", x.chart.series);
        console.log("Original Labels:", x.chart.labels);

        let filteredSeries;
        if (
          x.chart.type.toLowerCase() === "pie" ||
          x.chart.type.toLowerCase() === "donut"
        ) {
          // For Pie or Donut Charts
          filteredSeries = hidePerson
            ? x.chart.series[0].data.slice(0, -1)
            : x.chart.series[0].data;
        } else {
          // For other types of charts
          // filteredSeries = x.chart.series;
          filteredSeries = hidePerson
            ? x.chart.series.filter(
                (series) => series.name.toLowerCase().includes("person")
              )
            : x.chart.series;
        }
        console.log("Filtered Series:", filteredSeries);

        // Filter out the "Person" label if site id is 36
        const filteredLabels = x.chart.labels.filter((label, index) => {
          return !hidePerson || index !== x.chart.labels.length - 1;
        });

        console.log("Filtered Labels:", filteredLabels);

        const chart = {
          ...x,
          chart: {
            ...x.chart,
            type: x.chart.type.toLowerCase(),
            series: filteredSeries, // Use the filtered series data
          },
          chartOptions: {
            colors: x.chart.colors,
            chart: {
              type: x.chart.type.toLowerCase(),
              toolbar: { show: false },
            },
            yaxis: {
              title: {
                text: "Unit",
              },
              labels: {
                minWidth: 40,
              },
            },
            dataLabels: {
              enabled: x.chart.type.toLowerCase() === "donut",
              formatter: function (val) {
                return val.toFixed(2) + "%";
              },
            },
            labels: filteredLabels, // Use the filtered labels
            xaxis: {
              categories: x.chart.categories,
            },
            fill: {
              opacity: 1,
            },
            markers: {
              size: 6,
            },
            stroke: {
              width: 2,
            },
          },
        };
        this.charts.push(chart);
      });
    },
    //DEFAULT
    // buildChartData() {
    //   this.lists.map((x) => {
    //     const chart = {
    //       ...x,
    //       chart: {
    //         ...x.chart,
    //         type: x.chart.type.toLowerCase(),
    //         series:
    //           x.chart.type.toLowerCase() == "pie" ||
    //           x.chart.type.toLowerCase() == "donut"
    //             ? x.chart.series[0].data
    //             : x.chart.series,
    //       },
    //       chartOptions: {
    //         colors: x.chart.colors,
    //         chart: {
    //           type: x.chart.type.toLowerCase(),
    //           toolbar: { show: false },
    //         },
    //         yaxis: {
    //           title: {
    //             text: "Unit",
    //           },
    //           labels: {
    //             minWidth: 40,
    //           },
    //         },
    //         dataLabels: {
    //           enabled:
    //             x.chart.type.toLowerCase() == "donut" ||
    //             x.chart.type.toLowerCase() == "donut"
    //               ? true
    //               : false,
    //           formatter: function (val) {
    //             return val.toFixed(2) + "%";
    //           },
    //         },
    //         labels: x.chart.labels,
    //         xaxis: {
    //           categories: x.chart.categories,
    //         },
    //         fill: {
    //           opacity: 1,
    //         },
    //         markers: {
    //           size: 6,
    //         },
    //         stroke: {
    //           width: 2,
    //         },
    //       },
    //     };
    //     this.charts.push(chart);
    //   });
    // },
    //DEFAULT IN OUT
    // buildChartDataInOut() {
    //   const seriesData = this.lists[0].chart.series;
    //   const categories = this.lists[0].chart.categories;
    //   const colors = this.lists[0].chart.colors;

    //   // Define vehicle types
    //   const vehicleTypes = ["Car", "Motorcycle", "Other Vehicle", "Person"];

    //   // Loop through vehicle types
    //   vehicleTypes.forEach((type, index) => {
    //     const chart = {
    //       name: `${type} Chart`,
    //       chartOptions: {
    //         colors: [colors[index * 2], colors[index * 2 + 1]],
    //         chart: {
    //           type: "line",
    //           toolbar: { show: false },
    //         },
    //         yaxis: {
    //           title: {
    //             text: "Unit",
    //           },
    //           labels: {
    //             minWidth: 40,
    //           },
    //         },
    //         labels: [],
    //         xaxis: {
    //           categories,
    //         },
    //         fill: {
    //           opacity: 1,
    //         },
    //         markers: {
    //           size: 6,
    //         },
    //         stroke: {
    //           width: 2,
    //         },
    //       },
    //       chart: {
    //         type: "line",
    //         series: [
    //           {
    //             name: `${type} In`,
    //             data: this.prependZero(
    //               seriesData.find((item) => item.name === `${type} In`).data
    //             ),
    //           },
    //           {
    //             name: `${type} Out`,
    //             data: this.prependZero(
    //               seriesData.find((item) => item.name === `${type} Out`).data
    //             ),
    //           },
    //         ],
    //       },
    //     };

    //     // Add 0 values for each series without cloning
    //     chart.chart.series.forEach((s) => {
    //       this.prependZero(s.data);
    //     });

    //     // Use dynamic categories based on actual data
    //     chart.chartOptions.xaxis.categories = categories;

    //     this.chartsInOut.push(chart);
    //   });
    // },

    // buildChartDataInOut() {
    //   const seriesData = this.lists[0].chart.series;
    //   const categories = this.lists[0].chart.categories;
    //   const colors = this.lists[0].chart.colors;

    //   // Define vehicle types
    //   const vehicleTypes = ["Car", "Motorcycle", "Other Vehicle", "Person"];

    //   // Check if site id is 36
    //   const hidePerson = this.site === 36;

    //   // Loop through vehicle types
    //   vehicleTypes.forEach((type, index) => {
    //     // Exclude person data if site id is 36
    //     if (type === "Person" && hidePerson) return;

    //     const chart = {
    //       name: `${type} Chart`,
    //       chartOptions: {
    //         colors: [colors[index * 2], colors[index * 2 + 1]],
    //         chart: {
    //           type: "line",
    //           toolbar: { show: false },
    //         },
    //         yaxis: {
    //           title: {
    //             text: "Unit",
    //           },
    //           labels: {
    //             minWidth: 40,
    //           },
    //         },
    //         labels: [],
    //         xaxis: {
    //           categories,
    //         },
    //         fill: {
    //           opacity: 1,
    //         },
    //         markers: {
    //           size: 6,
    //         },
    //         stroke: {
    //           width: 2,
    //         },
    //       },
    //       chart: {
    //         type: "line",
    //         series: [
    //           {
    //             name: `${type} In`,
    //             data: this.prependZero(
    //               seriesData.find((item) => item.name === `${type} In`).data
    //             ),
    //           },
    //           {
    //             name: `${type} Out`,
    //             data: this.prependZero(
    //               seriesData.find((item) => item.name === `${type} Out`).data
    //             ),
    //           },
    //         ],
    //       },
    //     };

    //     // Add 0 values for each series without cloning
    //     chart.chart.series.forEach((s) => {
    //       this.prependZero(s.data);
    //     });

    //     // Use dynamic categories based on actual data
    //     chart.chartOptions.xaxis.categories = categories;

    //     this.chartsInOut.push(chart);
    //   });
    // },

    buildChartDataInOut() {
      const seriesData = this.lists[0].chart.series;
      const categories = this.lists[0].chart.categories;
      const colors = this.lists[0].chart.colors;

      // Define vehicle types
      const vehicleTypes = ["Car", "Motorcycle", "Other Vehicle", "Person"];

      // Check if site id is 36
      // const hidePerson = this.site === 36;

      // Loop through vehicle types
      vehicleTypes.forEach((type, index) => {
        // Exclude person data if site id is 36
        // if (type === "Person" && hidePerson) return;

        // Find the series data for "in" and "out" categories
        const inDataItem = seriesData.find(
          (item) => item.name === `${type} In`
        );
        const outDataItem = seriesData.find(
          (item) => item.name === `${type} Out`
        );

        // Initialize arrays to hold "in" and "out" data
        const inData = inDataItem ? this.prependZero(inDataItem.data) : [];
        const outData = outDataItem ? this.prependZero(outDataItem.data) : [];

        // Create the chart object
        const chart = {
          name: `${type} Chart`,
          chartOptions: {
            colors: [colors[index * 2], colors[index * 2 + 1]],
            chart: {
              type: "line",
              toolbar: { show: false },
            },
            yaxis: {
              title: {
                text: "Unit",
              },
              labels: {
                minWidth: 40,
              },
            },
            labels: [],
            xaxis: {
              categories,
            },
            fill: {
              opacity: 1,
            },
            markers: {
              size: 6,
            },
            stroke: {
              width: 2,
            },
          },
          chart: {
            type: "line",
            series: [
              {
                name: `${type} In`,
                data: inData,
              },
              {
                name: `${type} Out`,
                data: outData,
              },
            ],
          },
        };

        // Add 0 values for each series without cloning
        chart.chart.series.forEach((s) => {
          this.prependZero(s.data);
        });

        // Use dynamic categories based on actual data
        chart.chartOptions.xaxis.categories = categories;

        // Push the chart object to the chartsInOut array
        this.chartsInOut.push(chart);
      });
    },

    prependZero(data) {
      // Check if the array is empty before adding a zero
      if (data.length === 0) {
        data.push(0);
      }
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
.car-chart-class {
  color: #4e73df;
  font-weight: bold;
  font-size: medium;
}

.motorcycle-chart-class {
  color: #e74a3a;
  font-weight: bold;
  font-size: medium;
}
.other-vehicle-chart-class {
  color: #848796;
  font-weight: bold;
  font-size: medium;
}
.person-chart-class {
  color: #1bc88a;
  font-weight: bold;
  font-size: medium;
}
</style>
